import React from 'react'
import gql from 'graphql-tag'
import DeliveredUrl from 'components/shared/DeliveredUrl'
import DefaultProductStatus from '../../DefaultProductStatus'
import ProvideInput from './ProvideInput'

const SlideshowProduct = ({match, product}) => {
  if (product.canProvideUserInput) {
    return (
      <ProvideInput
        estateId={match.params.estateId}
        product={product}
      />
    )
  }

  if (product.state === 'delivered') {
    return (
      <DeliveredUrl product={product} />
    )
  }

  return (
    <DefaultProductStatus product={product} />
  )
}

SlideshowProduct.fragment = gql`
  fragment SlideshowProduct on Product {
    ...on SlideshowProduct {
      roomsPriority
      slideshowFacts
      availableInputAssets {
        ...SlideshowAssets
      }
      inputAssets {
        ...SlideshowAssets
      }
      assets {
        ...SlideshowAssets
      }
    }
  }
  fragment SlideshowAssets on AssetsConnection {
    edges {
      node {
        id
        state
        ...on PhotoAsset {
          image(size: "monitor") {
            url
            thumbUrl
            width
            height
            labels
            filenameIndex
          }
        }
        ...on UrlAsset {
          url
        }
      }
    }
  }
`

export default SlideshowProduct
